import { dateSameDay } from '../utils/date';
class Szuro {
  CreateSzurok(arrayOfobj, szuroProps, selectedSzurok) {
    let szurok = new Map();
    arrayOfobj.forEach(obj => {
      szuroProps.forEach(szuroProp => {
        let elements = [];
        if (Array.isArray(obj[szuroProp.propId])) {
          let elementsArr = obj[szuroProp.propId];
          elementsArr.forEach(element => {
            elements.push({
              Id: element,
              Nev: element,
              count: 0,
            });
          });
        } else {
          elements.push({
            Id: obj[szuroProp.propId],
            Nev: obj[szuroProp.propNev],
            count: 0,
          });
        }
        elements.forEach(element => {
          if (!element.Id || !element.Nev) {
            return;
          }

          element.szuro = { ...szuroProp };
          let key = element.szuro.propNev + element.Id;
          let mentettElement = szurok.get(key);
          if (!mentettElement) {
            let ujElement = { ...element };
            ujElement.count = 1;
            szurok.set(key, ujElement);
          } else {
            mentettElement.count++;
            szurok.set(key, mentettElement);
          }
        });
      });
    });
    let szurokArr = Array.from(szurok.values());
    let hianyzoSzurok = selectedSzurok.filter(
      f => !szurokArr.some(s => s.szuro.propNev + '' + s.Id == f.key)
    );
    hianyzoSzurok.forEach(element => {
      szurokArr.push({ ...element.value });
    });

    return szurokArr;
  }
  ValidateSzurok(selectedSzurok, obj) {
    // Ha true, nem jelenik meg az elem a listában
    let tempBool = false;

    for (let i = 0; i < selectedSzurok.length; i++) {
      const selectedSzuro = selectedSzurok[i];
      let prefix = selectedSzuro.szuro.prefix;

      if (prefix) {
        tempBool = true;
        for (let i = 0; i < prefix.length; i++) {
          if (
            obj[prefix[i]][selectedSzuro.szuro.propNev] &&
            obj[selectedSzuro.szuro.propId] == selectedSzuro.Id
          ) {
            tempBool = false;
          }
        }

        if (tempBool) {
          return tempBool;
        }
      } else {
        if (Array.isArray(obj[selectedSzuro.szuro.propId])) {
          if (
            !obj[selectedSzuro.szuro.propId].includes(selectedSzuro.Id) &&
            !tempBool
          ) {
            tempBool = true;
          }
        } else {
          if (
            obj[selectedSzuro.szuro.propId] != selectedSzuro.Id &&
            !tempBool
          ) {
            tempBool = true;
          }
        }
      }
    }
    return tempBool;
  }
  MaiNapSzuro(list) {
    return list.map(m => {
      let obj = { ...m, IsToday: this.isToday(m.Idopont) ? 'Mai' : null };
      return obj;
    });
  }
  isToday(idopont) {
    const today = new Date();
    return dateSameDay(today, new Date(idopont));
  }
}
export const SzuroFunctions = new Szuro();
